module.exports = __webpack_public_path__ + "img/ping-pong_on.face6b68.svg";